    export const formatedDateClient = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB');
    };


    export const formatedDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0].replace(/-/g, '/');
    };


    export const formatedDBDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };
    